import axios from 'axios'

export default {
  search: function (request) {
    if(request.male == 1) {
      request.male = null
    }
    if(request.hasImar == 1) {
      request.hasImar = null
    }
    return axios.get('/api/journal/search', { params: request })
  },
  getNsi: function(dictName, request) {
    return axios.get('/api/nsi/' + dictName, { params: request })
  },
  find: function (id, config = {}) {
    return axios.get('/api/journal/find?id='+id, config)
  },
  getById: function (id) {
    return axios.get('/api/journal/getById?id='+id)
  },
  save: function (data) {
    return axios.post('/api/journal/save', data)
  },
  saveRoute: function (data) {
    return axios.post('/api/journalroute/save', data)
  },
}
